"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPageLoadBase = void 0;
/**
 * General page load analytic to be implemented by clients
 *
 * Event type: Page load
 * */
const trackPageLoadBase = (eventTracker, props) => {
    eventTracker("Page Load", props);
};
exports.trackPageLoadBase = trackPageLoadBase;
//# sourceMappingURL=BaseEvents.js.map